/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */
import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_helpers";

export function QuickUser() {
  const userName = sessionStorage.getItem("loggedUserName");
  const userEmail = sessionStorage.getItem("loggedUserEmail");

  const logoutClick = () => {
    sessionStorage.removeItem('loggedUserToken');
    sessionStorage.removeItem('loggedUserEmail');
    sessionStorage.removeItem('loggedUserRole');
    sessionStorage.removeItem('loggedUserName');
    sessionStorage.removeItem('loggedUserSigla');
    window.location.reload();
  };

  return (
    <div id="kt_quick_user" className="offcanvas offcanvas-right offcanvas p-10">
      <div className="offcanvas-header d-flex align-items-center justify-content-between pb-5">
        <h3 className="font-weight-bold m-0">
          <FormattedMessage id="USER.PROFILE" />
          {/* <small className="text-muted font-size-sm ml-2">12 messages</small> */}
        </h3>
        <a
          href="#"
          className="btn btn-xs btn-icon btn-light btn-hover-primary"
          id="kt_quick_user_close"
        >
          <i className="ki ki-close icon-xs text-muted" />
        </a>
      </div>

      <div className="offcanvas-content pr-5 mr-n5">
        <div className="d-flex align-items-center mt-5">
          <div className="d-flex flex-column">
            <a
              href="#"
              className="font-weight-bold font-size-h5 text-dark-75 text-hover-primary"
            >
              {userName}
            </a>
            <div className="text-muted mt-1">Pneumologo</div>
            <div className="navi mt-2">
              <a href="#" className="navi-item">
                <span className="navi-link p-0 pb-2">
                  <span className="navi-icon mr-1">
                    <span className="svg-icon-lg svg-icon-primary">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Communication/Mail-notification.svg"
                        )}
                      ></SVG>
                    </span>
                  </span>
                  <span className="navi-text text-muted text-hover-primary">
                    {userEmail}
                  </span>
                </span>
              </a>
            </div>
            {/* <Link to="/logout" className="btn btn-light-primary btn-bold">
                Sign Out
              </Link> */}
            <Link to="/change-password" className="w-100 mt-5">
              <button className="btn btn-outline-primary btn-bold w-100">
                <FormattedMessage id="GENERAL.CHANGE_PASSWORD" />
              </button>
            </Link>
            <button
              className="btn btn-light-primary btn-bold w-100 mt-3"
              onClick={logoutClick}
            >
              <FormattedMessage id="USER.LOGOUT" />
            </button>
          </div>
        </div>



      </div>
    </div>
  );
}
